import { createContext, useContext, useState } from "react";

interface SelectedRowsProviderProps {
  children: React.ReactNode;
}

type SelectedRowsContextType = {
  selectedRows?: any[];
  setSelectedRows: (selectedRows: any) => void;
};

export const SelectedRowsContext = createContext<SelectedRowsContextType>({
  selectedRows: [],
  setSelectedRows: () => {},
});

const SelectedRowsProvider = (props: SelectedRowsProviderProps) => {
  const [selectedRows, setSelectedRows] = useState<any[]>();

  return (
    <SelectedRowsContext.Provider value={{ selectedRows, setSelectedRows }}>
      {props.children}
    </SelectedRowsContext.Provider>
  );
};

export default SelectedRowsProvider;

export const useSelectedRows = () => {
  const { selectedRows, setSelectedRows } = useContext(SelectedRowsContext);
  return { selectedRows, setSelectedRows };
};
